if (!customElements.get('routine-tabs')) {
  customElements.define(
    'routine-tabs',
    class RoutineTabs extends HTMLElement {
      connectedCallback() {
        this.steps = [...this.querySelectorAll('.routine-step')];
        this.visualImage = this.querySelector('[data-routine-visual-image]');
        this.badgeLabel = this.querySelector('[data-routine-badge-label]');
        this.badgeProduct = this.querySelector('[data-routine-badge-product]');

        this.steps.forEach((step, index) => {
          step.addEventListener('click', () => this.activate(index));
        });
      }

      activate(index) {
        const active = this.steps[index];
        if (!active) return;

        this.steps.forEach((step, i) => {
          const isActive = i === index;
          step.classList.toggle('routine-step--active', isActive);
          step.setAttribute('aria-expanded', isActive);
        });

        const img = active.dataset.image;
        const product = active.dataset.product;

        if (img && this.visualImage) this.visualImage.src = img;
        if (this.badgeLabel) this.badgeLabel.textContent = `Paso ${index + 1}`;
        if (this.badgeProduct) this.badgeProduct.textContent = product || '';
      }
    }
  );
}
